// pdf를 빠르게 생성가능. but 일일히 styling필요
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useToast } from '@components/common/toast';
import FileUtil from '@utils/fileUtil';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  Pretendard: {
    normal: 'https://fastly.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Medium.woff',
    bold: 'https://fastly.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Bold.woff',
    italics: 'https://fastly.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Medium.woff',
    bolditalics: 'https://fastly.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-ExtraBold.woff',
  },
};

export const getBase64ImageFromUrl = async (url: string): Promise<string> => {
  const res = await fetch(url);
  const blob = await res.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

const usePdfMake = () => {
  const Toast = useToast();

  const downloadPdf = async (docDefinition: any, fileName: string) => {
    try {
      const pdfDocGenerator = pdfMake.createPdf(docDefinition);
      pdfDocGenerator.getBuffer(async (buffer) => {
        const arrayBuffer = buffer.buffer.slice(buffer.byteOffset, buffer.byteOffset + buffer.byteLength);
        FileUtil.fileDownload(`${fileName}`, arrayBuffer);
      });
      Toast({ type: 'success', iconType: 'check', content: '다운로드가 완료되었습니다.' });
    } catch (error) {
      Toast({ type: 'error', iconType: 'info', content: '다운로드를 실패했습니다.' });
    }
  };

  return { downloadPdf };
};

export default usePdfMake;
